import React from "react";
import { OtpType } from "../../../pages/verifyEmailForRegistration";

interface inputProps {
  value: string;
  inputName: string;
  keyHandler: (e: any) => void;
  changeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
const Input = ({ keyHandler, changeHandler, inputName, value }: inputProps) => {
  return (
    <input
      placeholder="0"
      type={"text"}
      onKeyDown={(e) => keyHandler(e)}
      name={inputName}
      id={inputName}
      value={value}
      onChange={(e) => changeHandler(e)}
      className={
        "border border-slate-300 outline-none focus:border-violet-500 rounded-md p-0 sm:w-[50px] md:w-[60px] sm:h-[50px] md:h-[60px] sm:text-2xl md:text-3xl flex justify-center items-center text-center leading-[60px]"
      }
    />
  );
};

interface props {
  data: OtpType;
  setData: React.Dispatch<React.SetStateAction<OtpType>>;
}

const OtpInput = ({ data, setData }: props) => {
  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regex = new RegExp("[0-9]");
    const value = regex.test(e.target.value) ? e.target.value : "";

    if (e.target.name === "input1") {
      setData({ ...data, one: value.slice(-1) });
      if (value !== "") {
        document.getElementById("input2")?.focus();
      }
    } else if (e.target.name === "input2") {
      setData({ ...data, two: value.slice(-1) });
      if (value !== "") {
        document.getElementById("input3")?.focus();
      }
    } else if (e.target.name === "input3") {
      setData({ ...data, three: value.slice(-1) });
      if (value !== "") {
        document.getElementById("input4")?.focus();
      }
    } else if (e.target.name === "input4") {
      setData({ ...data, four: value.slice(-1) });
    }
  };

  const keyHandler = (e: any) => {
    if (e.key === "Backspace") {
      if (e.target.name === "input4" && data.four === "") {
        document.getElementById("input3")?.focus();
      } else if (e.target.name === "input3" && data.three === "") {
        document.getElementById("input2")?.focus();
      } else if (e.target.name === "input2" && data.two === "") {
        document.getElementById("input1")?.focus();
      }
    }
  };

  return (
    <div className="flex w-full sm:gap-3 md:gap-5 justify-center items-center">
      <div className="text-4xl text-violet-500 sm:hidden md:block">
        <i className="fa-solid fa-caret-right"></i>
      </div>
      <Input
        keyHandler={keyHandler}
        changeHandler={changeHandler}
        inputName={"input1"}
        value={data.one}
      />
      <Input
        keyHandler={keyHandler}
        changeHandler={changeHandler}
        inputName={"input2"}
        value={data.two}
      />
      <Input
        keyHandler={keyHandler}
        changeHandler={changeHandler}
        inputName={"input3"}
        value={data.three}
      />
      <Input
        keyHandler={keyHandler}
        changeHandler={changeHandler}
        inputName={"input4"}
        value={data.four}
      />
      <div className="text-4xl text-violet-500 sm:hidden md:block">
        <i className="fa-solid fa-caret-left"></i>
      </div>
    </div>
  );
};

export default OtpInput;
